import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import axios from 'axios';

const FaceRegister = () => {
  const webcamRef = useRef(null); // Reference to the webcam component
  const [registrationStatus, setRegistrationStatus] = useState(''); // State to store registration status message
  const [name, setName] = useState(''); // State to store the name input

  const handleRegister = async () => {
    if (webcamRef.current && name) {
      // Capture an image from the webcam
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        setRegistrationStatus('Failed to capture image. Please try again.');
        return;
      }
      try {
        // Send the captured image and name to the backend for registration
        console.log('Sending registration request:', { name, image: imageSrc }); // Debug log
        const response = await axios.post('/register_face', {
          image: imageSrc,
          name: name,
        });
        setRegistrationStatus(response.data.message);
      } catch (error) {
        console.error('Error during registration:', error); // Debug log for error
        setRegistrationStatus('Failed to register face. Please try again.');
      }
    } else {
      setRegistrationStatus('Please enter a name before registering.');
    }
  };

  return (
    <div>
      <h1>Face Register Page</h1>
      <input
        type="text"
        placeholder="Enter name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Webcam
        audio={false} // Disable audio as it's not needed for face registration
        ref={webcamRef} // Attach the webcam reference
        screenshotFormat="image/jpeg" // Set the format of the captured image
        width={400} // Width of the webcam view
        height={300} // Height of the webcam view
      />
      <button onClick={handleRegister}>Register Face</button>
      {/* Display the registration status message if available */}
      {registrationStatus && <p>{registrationStatus}</p>}
    </div>
  );
};

export default FaceRegister;
